export enum XeroStatusEnums {
    AUTHORISED = 'Awaiting Payment',
    DRAFT = 'Draft',
    PAID = 'Paid',
    OVERDUE="Overdue",
    SUBMITTED="Submitted"
}

